import { CardVariants } from '@anm/components/Card';
import StockModal from '@anm/components/stocks/StocksModal';
import isMobile from '@anm/helpers/is/isMobile';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { stockSelectors } from '../../../store/modules/stocks';
import { userSelectors } from '../../../store/modules/user';
import { ApplicationState } from '../../../store/types';
import AnonSignUpButton from '../../auth/AnonSignUpButton';

import { useAddStock, useTemplateFromStockUrl } from './hooks';

const cardSettings = {
  hasShadow: false,
  isPadding: false,
  variant: 'transparent' as CardVariants,
  minWidth: isMobile() ? 'unset' : `700px`
};

type StockViewModalProps = {
  stockId: string;
  priceValue: string;
  onModalClose(): void;
};

const StockModalView: FC<StockViewModalProps> = ({ stockId, priceValue, onModalClose }) => {
  const user = useSelector(userSelectors.selectUserProfile);
  const selectedStock = useSelector((state: ApplicationState) => stockSelectors.selectStockById(state, stockId));

  const { type, preview_url, thumbnail_url, ...otherProps } = selectedStock;
  const handleAddStock = useAddStock(selectedStock, onModalClose);
  const templateFromStockUrl = useTemplateFromStockUrl(selectedStock);
  const isVideo = type === 'STOCK_VIDEO';

  return (
    <StockModal
      {...{
        isVideo,
        priceValue,
        videoUrl: preview_url,
        onModalClose,
        cardSettings,
        thumbnail_url,
        handleAddStock,
        templateFromStockUrl,
        ...otherProps
      }}
      renderAnonButton={
        !user ? ({ onClick, ...props }) => <AnonSignUpButton {...props} onSignUpDone={onClick} /> : undefined
      }
    />
  );
};

export default StockModalView;
